import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'

import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import styles from '../styles'
import DocumentLink from '../../../../../Assets/Images/icons/documentLink'
import TrashCanIcon from '../../../../../Assets/Images/icons/trashCan'
import { Checkbox } from '@material-ui/core'

const GrayCircularProgress = withStyles({
  root: {
    color: 'hsl(214, 17%, 57%)',
  },
})(CircularProgress)

const ClientQuestionsView = ({
  onDelete,
  isDeleting,
  pitchUrl,
  fileUploader,
  onEnforceQuizResultWeeklyTermination,
  quizUpdating,
  quizData,
  children,
  classes,
}) => {
  return (
    <section className={classes.wrapper}>
      <section className={classes.whiteBlock}>
        <div className={classes.textWrapper}>
          <span className={classes.largeText}>Client Pitch </span>
          <span className={classes.smallText}>(1 page - PDF)</span>
        </div>
        {quizData.id && (
          <div className={classes.switchContainer}>
            <Checkbox
              checked={quizData.weekly}
              onChange={onEnforceQuizResultWeeklyTermination}
              disabled={quizUpdating}
            />
            <span style={{ paddingRight: 10 }}>
              Enforce Weekly BA Questionnaire
            </span>
            {quizUpdating && <CircularProgress size={10} />}
          </div>
        )}
        <div
          className={classnames(classes.contentWrapper, {
            [classes.contentWrapperWithPitch]: !!pitchUrl,
          })}
        >
          <div className={'ClientQuestionsView-existingPitchContainer'}>
            <a
              className={classnames(
                classes.pitchUrlContainer,
                classes.hoverOpacity,
              )}
              href={pitchUrl}
              target="_blank"
              rel="noreferrer"
            >
              <DocumentLink
                width={'25px'}
                height={'25px'}
                fill={'hsl(214, 17%, 57%)'}
              />
              <span>See Pitch</span>
            </a>
            <div
              className={classnames(
                classes.pitchUrlContainer,
                classes.hoverOpacity,
                { [classes.inactive]: isDeleting },
              )}
              href={pitchUrl}
              target="_blank"
              onClick={onDelete}
            >
              {isDeleting ? (
                <GrayCircularProgress size={25} />
              ) : (
                <TrashCanIcon
                  width={'25px'}
                  height={'25px'}
                  fill={'hsl(214, 17%, 57%)'}
                />
              )}
              <span>{isDeleting ? 'Deleting...' : 'Delete Pitch'}</span>
            </div>
          </div>
          <div
            className={classnames(
              'ClientQuestionsView-fileUploaderContainer',
              classes.hoverOpacity,
            )}
          >
            {fileUploader}
          </div>
        </div>
      </section>
      <section>{children}</section>
    </section>
  )
}

export default injectStyles(styles)(ClientQuestionsView)
